import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useCalculator } from "../use-calculator";
import { Graph } from "./graph";

export const CardGraph = () => {
  const { t } = useTranslation("calculator");
  const { value, data } = useCalculator();

  return (
    <div className="h-full">
      <h5 className="mb-8 w-full text-medium text-primary-content">
        {t("graph_title")}
      </h5>
      <div className="relative h-full">
        <div
          className={cn(
            { flex: !value, hidden: value },
            "absolute inset-0 -left-5 -right-5 bottom-5 z-10 items-center justify-center [backdropFilter:blur(4px)]",
          )}
        >
          <div className="max-w-56 text-center text-regular text-primary-content">
            {t("graph_empty_message")}
          </div>
        </div>
        <Graph data={data} />
      </div>
    </div>
  );
};
